export const REACT_LAYOUT_SCOPE_REACT = 'react'
export const REACT_LAYOUT_SCOPE_FORM_PERMALINK = 'form_permalink'